import { Box } from "@/components/layout/flexbox";
import { SUBTEXT_COLOR } from "@/css/constants";

interface GuestListProps {
  guests: string[];
  total: number;
  limit: number;
}

export function GuestsList({
  guests = [],
  total = 0,
  limit = 0,
}: GuestListProps) {
  if (total === 0) {
    return (
      <Box fontStyle="italic" color={SUBTEXT_COLOR}>
        No guests added
      </Box>
    );
  }

  const displayLimit = limit > 0 ? limit : 1000;
  const remainingGuests = Math.max(0, total - displayLimit);
  const displayedGuests = guests.slice(0, displayLimit);

  return (
    <Box>
      {displayedGuests.map((guest, index) => (
        <Box mt={index > 0 ? 1 : 0} key={`${guest}`}>
          {guest}
        </Box>
      ))}
      {remainingGuests > 0 ? (
        <Box py={2}>
          +{remainingGuests} <span>more</span>
        </Box>
      ) : null}
    </Box>
  );
}
